import { Modal, ModalContent } from '@braskai/ui-kit';

import { RECORDING_SURVEY_TEST_IDS } from '../../lib/constants';
import { useRecordingWelcomeSurveyForm } from '../../model/useRecordingWelcomeSurveyForm';
import { useRecordingWelcomeSurveyStore } from '../../model/useRecordingWelcomeSurveyStore';
import { QuestionStep } from '../QuestionStep';

export const RecordingWelcomeSurveyModal = () => {
  const isOpen = useRecordingWelcomeSurveyStore((s) => s.isOpen);
  const form = useRecordingWelcomeSurveyForm();

  if (!isOpen) return null;

  return (
    <Modal data-testid={RECORDING_SURVEY_TEST_IDS.modal} size="xs" open onClose={form.onDismiss}>
      <ModalContent noActions>
        <QuestionStep
          title={form.title}
          canGoBack={form.canGoBack}
          isContinueDisabled={form.isContinueDisabled}
          isOtherSelected={form.isOtherSelected}
          isRoleQuestion={form.currentQuestion === 'role'}
          options={form.options}
          otherText={form.otherText}
          selected={form.selected}
          subtitle={form.subtitle}
          onBack={form.onBack}
          onContinue={form.onContinue}
          onOtherTextChange={form.onOtherTextChange}
          onSelect={form.onSelect}
        />
      </ModalContent>
    </Modal>
  );
};
